import React, { useState } from "react";
import { ModalBody } from "react-bootstrap";
import { useMutation } from "react-query";
import { Modal, ModalHeader, Spinner } from "reactstrap";
import { postOptions } from "../../../MyApi/product/options";
import { toast } from "react-toastify";

const OptionsModal = ({ isModalOpen, closeModal ,refetch }) => {
  const [name, setName] = useState(" ");
  const [input_type, setInputType] = useState("single");
  const mutation = useMutation({
  mutationKey: ["postOptions"],
  mutationFn: (postData) => postOptions(postData),

  onSuccess: (data) => {
    toast.success(data.message);
    refetch();
    closeModal()
  },

  onError: (error) => {
    toast.error(error.response?.data?.message || "Something went wrong");
  },
});
  const handlePostRequest = () => {
    mutation.mutate({ name, input_type });
  };
  return (
    <Modal isOpen={isModalOpen}>
      <ModalHeader>
        <h5>إضافة مجموعة اختيار</h5>
        <p className="desc text-start">أضف مجموعة اختيار جديد لمنتجك</p>
      </ModalHeader>
      <ModalBody>
        <div className="mb-2 add">
          <label htmlFor="">اسم المجموعة</label>
          <input
            onChange={(e) => {
              setName(e.target.value);
            }}
            className="form-control"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="">النوع</label>
          <select
            name=""
            id=""
            onChange={(e) => setInputType(e.target.value)}
            className="form-select"
          >
            <option value="single">single</option>
            <option value="multiple">multiple</option>
          </select>
        </div>

        <div className="d-flex gap-2 mt-3">
          <button className="btn btn-primary" onClick={handlePostRequest} disabled={mutation.isLoading}>
          {mutation.isLoading ? <Spinner/>: "تأكيد"}
          </button>
          <button className="btn btn-white" onClick={closeModal}>
            إلغاء
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OptionsModal;
